import React from 'react';

const AmounTypeTitle = ({ record }) => {
	return <span>AmounType {record ? `"${record.name}"` : ''}</span>;
};

export default AmounTypeTitle;
